module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av184-ca548019ecf039e09b36643e4155af76.jpg";